export type UpdateInterfaceDeploymentRequestStatusRequest = {
  processTyp: string;
  dfnSetVerNum: string;
  dplymntReqSeq: string;
  tcktStsIdFrom: string;
  reviewComment?: string;
  updateDtimeTDplymntReqMng: string;
};
